module.exports = __webpack_public_path__ + "static/Cost Reduction 3-682b033ce368343dbe9f20e94f4b706e.png";